var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"100","height":"100","rx":"16","fill":"#DFDFDF","key":0}),React.createElement("path",{"d":"M11.592 72.808V27.592H21.96C50.976 27.592 50.976 72.808 21.96 72.808H11.592ZM9 25V75.4H21.96C54.72 75.4 54.72 25 21.96 25H9ZM88.5155 40.912H61.4435V25H58.8515V43.504H91.1075V25H88.5155V40.912ZM61.4435 59.488H88.5155V75.4H91.1075V56.896H58.8515V75.4H61.4435V59.488Z","fill":"#D66E00","key":1})]);
}

LogoInline.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
